export default __webpack_public_path__ + "static/media/Private_Equity_20230105.1fc0b535.pdf";